import React from 'react'
import { Modal, ModalHeader } from 'reactstrap';
import { FormTypePrecodedText } from './FormTypePrecodedText';
import { DeleteTypePrecodedText } from './DeleteTypePrecodedText';
import { Dialog } from 'primereact/dialog';


export const ModalTypePrecodedText = (props) => {
    const { modal, toggle, loading, method, name, handleInputChange, validaciones, saveCreate, saveUpdate, saveDelete, data, data2, changeOrder, arrayPrecod, changeArrayPrecod } = props;
    const modalTitle =
        method === 'create'
            ? 'Creación de tipo de texto precodificado'
            : method === 'update'
                ? 'Actualización de tipo de texto precodificado'
                : 'Eliminar tipo de texto precodificado';

    return (
        <Dialog
            // header={modalTitle}
            visible={modal}
            modal
            onHide={toggle}
            closable={false}
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">

                        <div className="Global-dialog-icon">
                            <i className="fa fa-gears f-20"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>


                        </div>

                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v`}

        >
            {method === 'create' ? (
                <FormTypePrecodedText
                    button="Crear texto precodificado"
                    {...{ toggle, loading, name, handleInputChange, validaciones, data, method, methodAction: saveCreate }}
                />
            ) : method === 'update' ? (
                <FormTypePrecodedText
                    button="Actualizar texto precodificado"
                    {...{
                        toggle,
                        loading,
                        name,
                        handleInputChange,
                        validaciones,
                        data,
                        method,
                        data2,
                        changeOrder,
                        arrayPrecod,
                        changeArrayPrecod,
                        methodAction: saveUpdate
                    }}
                />
            ) : (
                <DeleteTypePrecodedText {...{ toggle, name, saveDelete }} />
            )}
        </Dialog>
    )
}
